import React from 'react';
import type { InputBaseComponentProps } from '@mui/material';
import { useTheme } from '@mui/material';

const StripeInput = React.forwardRef<any, InputBaseComponentProps>(
  function StripeInput(props, ref) {
    const { component: Component, options, ...other } = props;
    const theme = useTheme();
    const [mountNode, setMountNode] = React.useState<any | null>(null);

    React.useImperativeHandle(
      ref,
      () => ({
        focus: () => mountNode.focus(),
      }),
      [mountNode]
    );

    return (
      <Component
        onReady={setMountNode}
        options={{
          ...options,
          style: {
            base: {
              color: theme.palette.text.primary,
              fontSize: '1rem',
              lineHeight: '1.5rem',
              fontFamily: 'Avenir',
            },
          },
        }}
        {...other}
      />
    );
  }
);

export default StripeInput;
